import { render, staticRenderFns } from "./SurveyManagement.vue?vue&type=template&id=df95cfa8&scoped=true"
import script from "./SurveyManagement.vue?vue&type=script&lang=js"
export * from "./SurveyManagement.vue?vue&type=script&lang=js"
import style0 from "./SurveyManagement.vue?vue&type=style&index=0&id=df95cfa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df95cfa8",
  null
  
)

export default component.exports